var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCrowd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 332.151 65.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:#2684ff;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.708,
    y1: 23.487,
    x2: 55.422,
    y2: 61.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Crowd-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.174,59.839c-3.607,2.376-9.327,3.432-15.312,3.432-19.007,0-29.743-11.439-29.743-29.655,0-17.6,10.736-29.919,29.567-29.919,5.632,0,11.264,1.056,15.4,4.048V15.4c-4.136-2.64-8.712-4.048-15.4-4.048-13.552,0-21.647,8.976-21.647,22.264S107.4,55.7,121.127,55.7a32.464,32.464,0,0,0,15.047-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.24,18.392h7.392v7.744c2.552-5.192,6.952-8.888,15.576-8.36v7.392c-9.68-.968-15.576,1.937-15.576,11.264v25.96H145.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.2,40.3c0-13.2,7.743-22.791,20.943-22.791,13.111,0,20.768,9.592,20.768,22.791s-7.656,22.968-20.768,22.968C178.943,63.271,171.2,53.5,171.2,40.3Zm7.392,0c0,8.36,4.136,15.928,13.552,15.928,9.327,0,13.375-7.567,13.375-15.928s-4.048-15.751-13.375-15.751C182.727,24.552,178.591,31.943,178.591,40.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.024,18.392h8.359L236.055,55.7,248.9,18.392h7.216L268.966,55.7l12.672-37.311H290l-16.191,44h-9.68l-7.567-21.3-4.048-13.552-4.048,13.552-7.568,21.3h-9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.582,54.471c-2.815,5.808-8.1,8.8-14.871,8.8-11.7,0-17.6-9.944-17.6-22.88,0-12.407,6.159-22.879,18.479-22.879,6.424,0,11.352,2.9,13.991,8.624V0h7.568V62.391h-7.568Zm-12.848,1.76c6.776,0,12.848-4.312,12.848-14.079V38.631c0-9.768-5.544-14.079-11.968-14.079-8.535,0-12.936,5.632-12.936,15.839C299.679,50.951,303.9,56.23,311.735,56.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.63,12.611,33,.97,1.37,12.611A2.092,2.092,0,0,0,0,14.651L.662,32.589C1.148,47.421,8.6,58.453,20.288,65.656a2.1,2.1,0,0,0,3.041-.963l6.815-16.075a1.038,1.038,0,0,0-.656-1.4,12.186,12.186,0,1,1,7.026,0,1.038,1.038,0,0,0-.656,1.4l6.815,16.075a2.1,2.1,0,0,0,3.041.963c11.688-7.2,19.14-18.235,19.625-33.066L66,14.651A2.092,2.092,0,0,0,64.63,12.611Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,23.374a12.179,12.179,0,0,1,3.513,23.843,1.038,1.038,0,0,0-.656,1.4l6.815,16.075a2.1,2.1,0,0,0,3.041.963c11.688-7.2,19.14-18.235,19.625-33.066L66,14.651a2.092,2.092,0,0,0-1.368-2.04L33,.97Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrowd);
export default __webpack_public_path__ + "static/media/logo-crowd.447acc14636404055b754ade2628d413.svg";
export { ForwardRef as ReactComponent };